import React from 'react'
import styled, { css } from 'styled-components'
import { ButtonUnstyled } from 'components/Button'
import { NavLink } from 'react-router-dom'

interface TabButtonProps {
  selected?: boolean
}

export const tabStyle = css<TabButtonProps>(
  ({ theme, selected }) => css`
    display: inline-block;

    padding: 8px 12px;

    color: ${selected
      ? theme.colors.primaryTint[100]
      : theme.colors.foreground.secondary[3]};
    background: ${selected ? theme.colors.primaryTint[10] : undefined};

    font-family: ${theme.fonts.buttons};
    font-size: ${theme.fontSizes.smaller};

    text-align: center;
    user-select: none;
    white-space: nowrap;
    border-radius: ${theme.radii.large};

    &:hover {
      color: ${selected ? undefined : theme.colors.foreground.secondary[1]};
    }
  `
)

export const TabButton = styled(ButtonUnstyled)`
  ${tabStyle};
`

export const TabDiv = styled.span`
  cursor: pointer;

  ${tabStyle};
`

export const TabLink = styled.a`
  ${tabStyle};
`

export interface TabProps {
  selected?: boolean
  /** This prop is deprecated, but still here for backwards compatibility */
  borderPosition?: 'top' | 'bottom'
  onTabSelected?: () => void
  urlFragment?: string
  externalUrl?: string
  className?: string
  isDisabled?: boolean
}

const Tab: React.FC<TabProps> = ({
  children,
  selected = false,
  urlFragment,
  onTabSelected,
  className,
  isDisabled,
  externalUrl,
}) => (
  <li className={className}>
    {urlFragment ? (
      <NavLink to={`#${urlFragment}`}>
        <TabDiv selected={selected} onClick={onTabSelected}>
          {children}
        </TabDiv>
      </NavLink>
    ) : externalUrl ? (
      <TabLink href={externalUrl} target="_blank">
        {children}
      </TabLink>
    ) : (
      <TabButton
        selected={selected}
        onClick={onTabSelected}
        disabled={isDisabled}>
        {children}
      </TabButton>
    )}
  </li>
)

export default Tab
